<template>
	<div>
		<load mode="table" v-if="loading" />
		<form v-else @submit.prevent="cadastardinamicaFamiliarRelacao" ref="addItem">
			<label class="d-block font-weight-bold mb-3"
				>Relação dos pais ou responsáveis com o profissional responsável pela visita:
				(na frente de cada item colocar a qual responsável se refere. Ex. pai, mãe, avó,
				avô.
			</label>
			<div class="row">
				<form-input
					v-model="responsavel"
					label="Responsável"
					grid="6"
					:required="true"
				/>
				<form-select
					v-model="tipo_relacao"
					:required="true"
					:itens="$root.arrays.acolhimento_tipo_relacao"
					label="Tipo Relação?"
					grid="6"
				/>
			</div>
			<div class="row col-12 pb-3 px-0 m-0 d-flex justify-content-end">
				<button class="btn btn-primary m-0" data-style="zoom-in" type="submit">
					Cadastrar
				</button>
			</div>
		</form>
		<div class="row">
			<div class="col-12" v-if="dinamicaFamiliarRelacao.length > 0">
				<table class="table table-sm border">
					<tbody>
						<tr v-for="(dinamica, index) in dinamicaFamiliarRelacao" :key="dinamica.id">
							<td scope="col">
								{{ dinamica.responsavel }}
							</td>
							<td scope="col">
								{{
									verificarValueArray(
										dinamica.tipo_relacao,
										$root.arrays.acolhimento_tipo_relacao
									)
								}}
							</td>
							<td scope="col">
								<button
									title="Excluir"
									@click="excluirDinamica(dinamica.id, index)"
									class="float-right btn px-2 mb-0 btn-danger btn-xs"
								>
									<i class="mdi mdi-close"></i>
								</button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="col-12" v-else>
				<h4 class="text-secondary">
					<i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
					Nada salvo aqui.
				</h4>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: ["item"],
	data() {
		return {
			responsavel: "",
			tipo_relacao: "",
			loading: false,
			dinamicaFamiliarRelacao: {},
		};
	},
	watch: {
		item() {
			if (this.item.dinamicaFamiliarRelacao != null) {
				this.dinamicaFamiliarRelacao = this.item.dinamicaFamiliarRelacao;
			}
		},
	},
	mounted() {
		if (this.item.dinamicaFamiliarRelacao != null) {
			this.dinamicaFamiliarRelacao = this.item.dinamicaFamiliarRelacao;
		}
	},
	methods: {
		submit() {
			this.item.dinamicaFamiliarRelacao = this.dinamicaFamiliarRelacao;
			this.$emit("submit");
		},
		cadastardinamicaFamiliarRelacao() {
			this.loading = true;
			let ladda = Ladda.create(document.querySelector(".btn-submit"));
			ladda.start();
			axios
				.post(
					`api/dashboard/acolhimento/storedinamicarelacao`,
					{
						responsavel: this.responsavel,
						tipo_relacao: this.tipo_relacao,
						acolhimento_id: this.item.id,
					},
					{
						header: { "Content-Type": "multipart/form-data" },
						onUploadProgress: (event) => {
							let progress = Math.round((event.loaded * 100) / event.total);
							this.progressCompleted = progress;
						},
					}
				)
				.then((response) => {
					ladda.stop();

					this.$snack.success({
						button: false,
						text: response.data.data.message,
					});
					this.$emit("reload");
				})
				.finally(() => {
					this.dinamica = "";
					this.tipo_relacao = "";
					this.loading = false;
				});
		},
		excluirDinamica(id) {
			swal.fire({
				text: "Aguarde a ação ser finalizada.",
				icon: "warning",
				showConfirmButton: false,
				timer: 1500,
			});
			axios
				.get(`api/dashboard/acolhimento/dinamica/excluir/${id}`)
				.then((response) => {
					this.$snack.success({
						button: false,
						text: response.data.data.message,
					});
					this.$emit("reload");
				});
		},
		verificarValueArray(value, array, valueIsArray = false) {
			if (valueIsArray && value) {
				var a = "";
				for (var i = 0; i < value.length; i++) {
					const result = array.filter((item) => item.id == value[i]);
					a += result[0].value + (i < value.length - 1 ? "," : "");
				}

				return a;
			} else {
				const result = array.filter((item) => item.id == value);
				return result[0] ? result[0].value : "";
			}
		},
	},
};
</script>
